import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import EmptyPage from "../ui/pages/EmptyPage";
import ShowHomeInteractor from "../interactor/main/ShowHomeInteractor";

export default class HomeArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes({
      path: "/error",
      page: this.createPage({
        Page: EmptyPage,
        action: () => {}
      }),
      options: {
        secure: false,
        initialProps: {
          title: "Error",
          text: "Page not found."
        }
      }
    });
  }

  public showHomePage() {
    return this.application.container
      .resolve<ShowHomeInteractor>("showHome")
      .execute();
  }
}
